// The class is empty because is only has static variables
export default class Constants {

}

Constants.BASE_URL_MATERIALS = 'https://d48f7equ64qjl.cloudfront.net/materials/'

Constants.BASE_PRODUCT_GLB = 'https://d48f7equ64qjl.cloudfront.net/product_assets/glb/'

export const MODEL_INSPECTOR_URL = 'https://d1rzyeqsmooian.cloudfront.net/model_inspector?id='

export const GLB_URL = 'https://d48f7equ64qjl.cloudfront.net/product_assets/glb/'

export const USDZ_URL = 'https://d48f7equ64qjl.cloudfront.net/product_assets/usdz/'

export const BRAND_ID_MAPPING = 'https://all3d.s3.us-west-2.amazonaws.com/Public_Viewer_Brand_ID_Mapping.json'

export const LOG_EMBED_URL = 'https://gqlip0wnzg.execute-api.us-west-2.amazonaws.com/production/embedable-player-analytics'

export const GET_PRODUCT_URL = 'https://gqlip0wnzg.execute-api.us-west-2.amazonaws.com/production/product-public-viewer-data-get'

export const CONFIGURATOR_INSPECTOR = 'https://d1gmu4ezl274zg.cloudfront.net/configurator_inspector/'

export const getPlatformSpecificBaseURL = (platform) => {
    let base_url = "";
    if (platform == "aws") {
        base_url = "https://d48f7equ64qjl.cloudfront.net/";
    }
    if (platform == "google") {
        base_url = "https://storage.googleapis.com/all3d/";
    }
    return base_url;
  };